/* global $, $$ */ /* Bliss */

import * as Sentry from '@sentry/browser'
import jsCookie from 'js-cookie'
import Flickity from 'flickity'
import 'flickity-imagesloaded'
import showToastNotification from './toastNotifications'

const getCsrfToken = function() {
  const csrfToken = $('[name=csrfmiddlewaretoken]')
  return csrfToken ? csrfToken.value : ''
}

const csrfFetch = function(url, data, headers, method = 'POST') {
  return $.fetch(url, {
    method: method,
    headers: Object.assign(
      {
        'Content-Type': 'application/json',
        'X-CSRFToken': getCsrfToken(),
      },
      headers
    ),
    data: data ? JSON.stringify(data) : {},
  })
}

export class Shop {
  constructor() {
    this.setupAddToCartButtons()
    this.setupCartListEditButtons()
    this.setupCartDeleteAllButton()
    this.setupFlickityCarousel()
    this.setupQuantityButtons()
    this.setupCartListAddCouponButton()
    this.setupUppercaseCouponCodeInput()
  }

  setupQuantityButtons() {
    const spinner = $('.detail-item__quantity')
    if (spinner !== null) {
      const input = $('input[type="number"]', spinner)
      const btnUp = $('.quantity-up', spinner)
      const btnDown = $('.quantity-down', spinner)
      const min = input.getAttribute('min')
      const max = input.getAttribute('max')

      btnUp._.bind('click', event => {
        event.preventDefault()
        const oldValue = parseFloat(input.value)
        input.value = oldValue >= max ? oldValue : oldValue + 1
        input._.fire('change')
      })

      btnDown._.bind('click', event => {
        event.preventDefault()
        const oldValue = parseFloat(input.value)
        input.value = oldValue <= min ? oldValue : oldValue - 1
        input._.fire('change')
      })

      input._.bind('blur', event => {
        event.preventDefault()
        const max = parseInt(input.max)
        if (parseInt(input.value) > max) {
          input.value = max
        }
      })
    }
  }

  setupFlickityCarousel() {
    const carousel = $('.shop-item-carousel')
    if (carousel) {
      new Flickity(carousel, {
        cellAlign: 'left',
        contain: true,
        wrapAround: true,
        imagesLoaded: true,
        //fullscreen: true,
        lazyLoad: true,
      })
    }
  }

  toggleCartButtons(target) {
    const button = $(target)
    const spinner = $('.add-to-cart-spinner', $(target))
    const cart = $('.fa-cart-plus', $(target))
    if (button.disabled) {
      cart._.style({display: 'inherit'})
      spinner._.style({display: 'none'})
      button.disabled = false
    } else {
      cart._.style({display: 'none'})
      spinner._.style({display: 'inherit'})
      button.disabled = true
    }
  }

  updateCarteBadge(items) {
    const orderId = jsCookie.get('orderId')
    const badge = $('.shopping-cart__badge')
    const shop = $('.shopping-cart')
    const name = $('.shopping-cart__name')
    if (orderId !== undefined) {
      shop.href = `/minishop/checkout/${orderId}/`
      badge._.style({display: 'inherit'})
      badge.innerText = parseInt(items) > 99 ? '+99' : items
      name.innerText = 'Poschtichörbli'
    } else {
      shop.href = '/shop/'
      badge._.style({display: 'hidden'})
      badge.innerText = ''
      name.innerText = 'Shop'
    }
  }

  updateCartButtons() {
    const orderId = jsCookie.get('orderId')
    $$('.shop-goto-checkout-button').forEach(button => {
      const link = $('a', button)
      link.href = `/minishop/checkout/${orderId}/`
      button.classList.remove('hide')
    })
  }

  setupCartDeleteAllButton() {
    const button = $('.shopping-cart-list__delete_all')
    if (button !== null) {
      button.addEventListener('click', e => {
        e.preventDefault()
        button.disabled = true
        const confirm = window.confirm(
          'Willst du dein Poschtichörbli leeren und zum Shop zurückkehren?'
        )
        if (confirm) {
          this.deleteOrder()
        }
        button.disabled = false
      })
    }
  }

  deleteOrder() {
    const orderId = jsCookie.get('orderId')
    csrfFetch(`/minishop/delete_order/${orderId}/`)
      .catch(err => {
        return Sentry.captureException(err)
      })
      .finally(() => {
        jsCookie.remove('orderId')
        window.location.replace('/shop/')
      })
  }

  setupCartListEditButtons() {
    $$('.shopping-cart-list .edit-cart-button')._.addEventListener(
      'click',
      e => {
        e.preventDefault()
        const button = e.currentTarget
        const orderItemId = button.getAttribute('x-orderItem-id')
        const orderItemAction = button.getAttribute('x-orderItem-action')
        const orderId = jsCookie.get('orderId')
        //TODO: if delete action remove whole line with animation
        button.disabled = true
        csrfFetch(`/minishop/update_order_item/${orderId}/`, {
          orderItemId,
          orderItemAction,
        })
          .then(res => {
            const response = JSON.parse(res.response)
            if (response.orderItemAmount === 0) {
              $$(`tr[x-orderItem-id="${orderItemId}"]`).forEach(tr => {
                tr.remove()
              })
              if (response.items === 0) {
                this.deleteOrder()
              }
            } else {
              $(
                `.shopping-cart-list__amount[x-orderItem-id="${orderItemId}"]`
              ).innerText = response.orderItemAmount
              $(
                `.shopping-cart-list__total span[x-orderItem-id="${orderItemId}"]`
              ).innerText = response.itemPrice
            }

            const reduction = $(
              `.shopping-cart-list__all-coupon span[x-order-id="${orderId}"]`
            )

            if (reduction !== null) {
              reduction.innerText = response.reduction
            }

            $(
              `.shopping-cart-list__all-total span[x-order-id="${orderId}"]`
            ).innerText = response.totalPrice
            this.updateCarteBadge(response.items)
          })
          .catch(err => {
            return Sentry.captureException(err)
          })
          .finally(() => {
            button.disabled = false
          })
      }
    )
  }

  setupCartListAddCouponButton() {
    $$('.shopping-cart-list__add_coupon')._.addEventListener('click', e => {
      e.preventDefault()
      const button = e.currentTarget
      const couponCode = $('#coupon_code').value
      if (couponCode === '') {
        return showToastNotification(
          'Bitte gültigen Gutschein Code eingeben.',
          undefined,
          true
        )
      }
      const orderId = jsCookie.get('orderId')
      button.disabled = true
      csrfFetch(`/minishop/add_coupon_code/${orderId}/`, {
        couponCode,
      })
        .then(res => {
          const response = JSON.parse(res.response)
          if (response.valid) {
            location.reload()
          } else {
            switch (response.message) {
              case 'coupon_404':
              case 'already_used':
              case 'coupon_invalid':
                showToastNotification(
                  'Gutschein ist nicht gültig.',
                  undefined,
                  true
                )
                break
              case 'coupon_minimum':
                showToastNotification(
                  `Du musst mindestens für CHF ${response.minimum}.- einkaufen.`,
                  undefined,
                  true
                )
                break
            }
          }
        })
        .catch(err => {
          Sentry.captureException(err)
          showToastNotification(
            'Unbekannter Fehler. Bitte versuche es später noch einmal oder schreibe uns eine Mail.',
            undefined,
            true
          )
        })
        .finally(() => {
          button.disabled = false
        })
    })
  }

  setupUppercaseCouponCodeInput() {
    $$('#coupon_code')._.addEventListener('change', e => {
      e.preventDefault()
      const input = e.currentTarget
      input.value = input.value.toUpperCase()
    })
  }

  setupAddToCartButtons() {
    $$('.add-to-cart')._.addEventListener('click', e => {
      e.preventDefault()
      const button = e.currentTarget
      const itemId = button.getAttribute('x-shop-id')
      this.toggleCartButtons(button)
      const variants = $(`#id_item_${itemId}_variant`)
      const variant =
        variants !== null ? variants.options[variants.selectedIndex].value : ''
      const amountInput = $(`#id_item_${itemId}_amount`)
      const amount = amountInput !== null ? amountInput.value : 1
      const orderId = jsCookie.get('orderId')
      csrfFetch(`/minishop/add_item/${orderId ? orderId + '/' : ''}`, {
        itemId,
        variant,
        amount,
      })
        .then(res => {
          const response = JSON.parse(res.response)
          jsCookie.set('orderId', response.orderId, {expires: 7})
          this.updateCarteBadge(response.items)
          this.updateCartButtons(response.orderId)
          showToastNotification(
            `👍 ${response.successText}`,
            `/minishop/checkout/${response.orderId}/`
          )
        })
        .catch(err => {
          Sentry.captureException(err)
          showToastNotification(
            'Ein Fehler ist aufgetreten. Bitte versuche es später noch einmal',
            undefined,
            true
          )
        })
        .finally(() => {
          this.toggleCartButtons(button)
        })
    })
  }
}
